import React, { type HTMLAttributes } from 'react';

import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { ChipYat } from '@pkg/components/Sections/Profile/Chips/ChipYat';

import { type EmojiId } from '@app/client/common/structs/emoji/emoji';

import { StyledSearchListItemSpacer, StyledSearchListItemWrapper } from './styles';

interface FreeYatItemData extends HTMLAttributes<HTMLDivElement> {
    yat: EmojiId;
    onClaim?: (yat: EmojiId) => void;
    focused?: boolean;
}

export function FreeYatItem({ yat, onClaim, focused, ...rest }: FreeYatItemData) {
    return (
        <StyledSearchListItemWrapper $noHover {...rest} $focused={focused}>
            <ChipYat yat={yat} size="smaller" />
            <StyledSearchListItemSpacer />
            <Button size="small" onClick={() => onClaim?.(yat)}>
                Claim Yat
            </Button>
        </StyledSearchListItemWrapper>
    );
}
